import { z } from "zod";

/**
 * The integrations page's view ids: the rows of its rail above the category
 * divider (`integration-rail.tsx`).
 *
 * Its own module so the route (which validates `?tab=`) and the rail (which
 * links to each view) share one vocabulary without importing each other — the
 * route already imports the page as its `component`, so the reverse would be a
 * cycle. Same shape as
 * `settings/subscription/subscription-tabs.ts`.
 */
export const integrationsTab = z.enum([
	"catalogue",
	"connected",
	"spaces",
	"apis",
	"mcp",
]);

export type IntegrationsTab = z.infer<typeof integrationsTab>;
